<template>
  <div class="wrapper ">
    <Sidebar />
    <div class="main-panel" id="main-panel">
      <Header />
      <div class="panel-header panel-header-sm">
        <canvas id="bigDashboardChart"></canvas>
      </div>
      <div class="content">
        <Loading v-if="loading === true" />
        <div class="row">
          <div class="card mb-3">
            <div class="card-header">
              <h4 class="card-title">Administrator Information:</h4>
              <h5 class="card-category">* Mandatory Fields</h5>
            </div>
            <div class="card-body">
              <div class="form-group">
                <div class="row mb-3">
                  <div class="col">
                    <input
                      v-model="superAdmin.firstName"
                      type="text"
                      placeholder="* First Name"
                      class="form-control"
                    />
                  </div>
                  <div class="col">
                    <input
                      v-model="superAdmin.lastName"
                      type="text"
                      placeholder="* Last Name"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col">
                    <input
                      v-model="superAdmin.email"
                      type="text"
                      placeholder="* Email Address"
                      class="form-control"
                    />
                  </div>
                  <div class="col">
                    <input
                      v-model="superAdmin.password"
                      :type="!viewPassword ? 'password' : 'text'"
                      placeholder="* Password"
                      class="form-control"
                    />
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col">
                    <a
                      class="ml-2"
                      style="font-size: 12px; cursor: pointer;"
                      @click="viewPassword = !viewPassword"
                      ><b>Show Password</b></a
                    >
                  </div>
                </div>

                <Alert
                  v-if="errorMessage.length > 0"
                  :message="errorMessage"
                  :error="true"
                />
                <Alert
                  v-if="successMessage.length > 0"
                  :message="successMessage"
                  :error="false"
                />

                <button class="btn btn-primary" @click="createSuperAdmin()">
                  Create
                </button>
              </div>
            </div>
          </div>
          <div class="content w-100" style="margin-top: 20px;">
            <div class="tabs">
              <a
                style="font-weight: 500;"
                @click="activeTab = 1"
                :class="[activeTab === 1 ? 'active' : '']"
                >Active Admins</a
              >
              <a
                style="font-weight: 500;"
                @click="activeTab = 2"
                :class="[activeTab === 2 ? 'active' : '']"
                >Suspended Admins</a
              >
            </div>
            <div id="row">
              <div v-if="activeTab === 1" class="card">
                <div class="card-body">
                  <v-client-table
                    :data="tableData"
                    :columns="columns"
                    :options="options"
                  >
                    <div
                      slot="thumbnail"
                      slot-scope="{ row }"
                      style="text-align: center;"
                    >
                      <img style="max-width: 3em;" :src="row.thumbnail" />
                    </div>

                    <div slot="actions" slot-scope="{ row }">
                      <button
                        @click="suspendMember(row)"
                        class="transparent-button"
                      >
                        <i class="delete-button fa fa-trash"></i> Suspend
                      </button>
                      <button
                        v-if="isSuperAdmin === true"
                        @click="deleteUser(row.id)"
                        class="transparent-button"
                      >
                        <i class="delete-button fa fa-trash"></i> Delete
                      </button>
                      <button
                        @click="resetPassword(row)"
                        class="transparent-button"
                      >
                        <i class="fa fa-undo"></i> Reset Password
                      </button>
                    </div>
                  </v-client-table>
                </div>
              </div>
              <div v-else class="card">
                <div class="card-body">
                  <v-client-table
                    :data="suspendedAdmins"
                    :columns="columns"
                    :options="options"
                  >
                    <div
                      slot="thumbnail"
                      slot-scope="{ row }"
                      style="text-align: center;"
                    >
                      <img style="max-width: 3em;" :src="row.thumbnail" />
                    </div>
                    <div slot="actions" slot-scope="{ row }">
                      <button
                        @click="unsuspendMember(row)"
                        class="transparent-button"
                      >
                        <i class="green-button fa fa-reply"></i> Unsuspend
                      </button>
                    </div>
                  </v-client-table>
                </div>
              </div>
            </div>
            <!-- <div  id="row">
            </div> -->
          </div>
        </div>
        <Alert
          v-if="errorMessage.length > 0"
          :message="errorMessage"
          :error="true"
        />
        <Alert
          v-if="successMessage.length > 0"
          :message="successMessage"
          :error="false"
        />
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Admins from "../controllers/admin.controller";
import Users from "../controllers/user.controller";
import Members from "../controllers/members.controller";
import isSuperAdmin from "../services/jwt/isSuperAdmin";
import passwordSecure from '../services/passwordSecure';

export default {
  name: "Admins",
  data: function() {
    return {
      activeTab: 1,
      superAdmin: {},
      loading: false,
      errorMessage: "",
      successMessage: "",
      isSuperAdmin: isSuperAdmin(localStorage.getItem("superAdmin")),
      columns: [
        "name",
        "thumbnail",
        "displayName",
        "email",
        "jobTitle",
        "actions",
      ],
      tableData: [],
      selectedMuseum: "",
      options: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        filterable: true,
        headings: {
          thumbnail: "Profile Picture",
          name: "Name",
          email: "Email",
          displayName: "Display Name",
          jobTitle: "Job Title",
          actions: "Actions",
        },
      },
      suspendedAdmins: [],
      viewPassword: false,
    };
  },
  beforeMount: async function() {
    this.loading = true;
    await this.getAdmins();
    this.loading = false;
  },
  methods: {
    async unsuspendMember(memberInfo) {
      this.successMessage = "";
      this.errorMessage = "";
      this.loading = true;

      let suspended = await Members.unsuspend(memberInfo.firebaseID);

      if (suspended === true) {
        this.successMessage = "User Unsuspended Successfully";
        await this.getAdmins();
        this.loading = false;
      } else {
        this.errorMessage = "Something went wrong while suspending the user";
        this.loading = false;
      }
      this.loading = false;
    },
    async deleteUser(userID) {
      if (!userID) {
        this.errorMessage = "UserID is missing";
        return;
      }

      this.loading = true;

      let updated = await Users.delete(userID);

      if (updated == false) {
        this.errorMessage = "Something went wrong while updating the curator";
      } else if (updated.error) {
        this.errorMessage = updated.error;
      } else {
        this.successMessage = "Curator deleted successfully";
        this.editing = false;
        this.selectedCurator = null;
        this.tableData = [];

        // Refresh the curator list
        this.getCurators();
      }
      this.loading = false;
    },
    async suspendMember(memberInfo) {
      this.successMessage = "";
      this.errorMessage = "";
      this.loading = true;

      let suspended = await Members.suspend(memberInfo.firebaseID);

      if (suspended === true) {
        this.successMessage = "User Suspended Successfully";
        await this.getAdmins();
        this.loading = false;
      } else {
        this.errorMessage = "Something went wrong while suspending the user";
        this.loading = false;
      }
      this.loading = false;
    },
    async createSuperAdmin() {
      this.loading = true;

      if (
        !this.superAdmin.firstName ||
        !this.superAdmin.lastName ||
        !this.superAdmin.email ||
        !this.superAdmin.password
      ) {
        this.errorMessage = "Please make sure all mandatory fields are filled";
        this.loading = false;
        return;
      }

      if (passwordSecure(this.superAdmin.password) === false) {
        this.errorMessage = "Password must be at least ten characters long, contain at least one uppercase letter, one number and two special characters"
        this.loading = false;
        return;
      }
      let created = await Admins.createSuperAdmin(this.superAdmin);
      if (created === false) {
        this.errorMessage = "Something went wrong creating the admin";
      } else if (created.error) {
        this.errorMessage = created.error;
      } else {
        this.superAdmin = {};
        this.errorMessage = ""
        this.successMessage = "Administrator Added";
        await this.getAdmins();
      }

      this.loading = false;
    },

    async getAdmins() {
      // Reset the table
      this.tableData = [];
      this.suspendedAdmins = [];
      // Get a fresh copy of the admins
      let admins = await Admins.getAdmins();
      if (admins.length > 0) {
        admins.forEach((admin) => {
          if (admin.suspended != 1) {
            this.tableData.push({
              id: admin.id,
              firebaseID: admin.firebase_id,
              thumbnail: admin.profile_pic,
              name: admin.name,
              email: admin.email,
              displayName: admin.display_name,
              jobTitle: admin.job_title,
            });
          } else {
            this.suspendedAdmins.push({
              id: admin.id,
              firebaseID: admin.firebase_id,
              thumbnail: admin.profile_pic,
              name: admin.name,
              email: admin.email,
              displayName: admin.display_name,
              jobTitle: admin.job_title,
            });
          }
        });
      }
    },

    async resetPassword(user) {
      if (!user.email) {
        this.errorMessage = "This user doesn't have an email on record.";
        return;
      }

      this.loading = true;

      this.successMessage = "";
      this.errorMessage = "";

      let emailSent = await Users.resetPassword(user.email);

      if (emailSent === true) {
        this.successMessage =
          "Reset password email successfully sent to member";
      } else {
        this.errorMessage =
          "Something went wrong while sending reset password email";
      }

      this.loading = false;
    },
  },
};
</script>
